import { TenantDomainId } from '../../store/features/pageConfig';

export const KNECT365_TERMS_AND_CONDITIONS_LINK =
  'https://tech.informa.com/terms-and-conditions/';
export const KNECT365_LOGO_URL =
  'https://knect365.com/uploads/knect365-email-logo.png';

export type Knect36DataType = {
  terms: string;
  logo: string;
};

const knect365Data: Knect36DataType = {
  terms: KNECT365_TERMS_AND_CONDITIONS_LINK,
  logo: KNECT365_LOGO_URL,
};

export const KNECT365_TENANT_MAP: Partial<
  Record<TenantDomainId, Knect36DataType>
> = {
  [TenantDomainId.KNECT365]: knect365Data,
  [TenantDomainId.TMTKNECT365]: knect365Data,
  [TenantDomainId.AUTOMOTIVE]: knect365Data,
  [TenantDomainId.TELECOMSTECHACADEMY]: knect365Data,
};

export function isKnect365Tenant(
  tenantId: TenantDomainId,
): boolean | undefined {
  return !!KNECT365_TENANT_MAP[tenantId];
}

export function knect365TermsUrl(tenantId: TenantDomainId): string | undefined {
  if (isKnect365Tenant(tenantId)) return KNECT365_TENANT_MAP[tenantId]?.terms;
}

export function knect365LogoUrl(tenantId: TenantDomainId): string | undefined {
  if (isKnect365Tenant(tenantId)) return KNECT365_TENANT_MAP[tenantId]?.logo;
}
